export default {
  props: {
    widgetData: Object
  },
  computed:{
    fieldsType(){
      return this.widgetData.presetName?.split('+');
    }
  }
}